import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@gumtree/ui-library';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { BackButton, SimpleHeader, SimpleHeaderContainer } from './simple-header.style';
import { NavLogo } from '../nav-bar/style';
import { ShellState } from '../../reducers/common';

const getShouldShowBackButton = (showBackButton?: boolean) => showBackButton !== false;

const Header = () => {
    const backLink = useSelector((state: ShellState) => state.simpleHeader?.backLink);
    const showBackButton = useSelector((state: ShellState) => state.simpleHeader?.showBackButton);
    const shouldShowBackButton = getShouldShowBackButton(showBackButton);

    const goBack = () => {
        if (backLink) {
            window.location.href = backLink;
        } else {
            window.history.back();
        }
    };

    return (
        <SimpleHeaderContainer>
            <SimpleHeader>
                {shouldShowBackButton && (
                    <BackButton onClick={goBack}>
                        <Icon type="chevron-l-light" size="small" />
                        Back to Ad
                    </BackButton>
                )}
                <NavLogo linkTo="/" {...qaAttribute('gumtree-logo')} data-testid="gumtree-logo" />
            </SimpleHeader>
        </SimpleHeaderContainer>
    );
};

export default Header;
